const ViewReportAccessControl = {
  Access: "ACCESS_POINT",
  Guest: "GUEST_PROFILE",
};

export default Object.freeze(ViewReportAccessControl);
